import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/components/legal/LegalPage";
import { TermsOfUse } from "@/components/legal/LegalModal";

export const Route = createFileRoute("/en/terms")({
  head: () => ({
    meta: [
      { title: "Terms of use — Sellavo" },
      { name: "description", content: "The terms for using Sellavo and publishing listings safely." },
      { property: "og:title", content: "Terms of use — Sellavo" },
      { property: "og:description", content: "The terms for using Sellavo and publishing listings safely." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/en/terms" }],
  }),
  component: () => <LegalPage title="Terms of use" intro="The terms for using Sellavo and publishing listings safely."><TermsOfUse /></LegalPage>,
});
